module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', {
    attrs: {
      "manual": _vm.isPad,
      "effect": "dark",
      "content": _vm.basedataGetName('SysTip', _vm.tipCode),
      "placement": "top"
    },
    model: {
      value: (_vm.tooltipVisible),
      callback: function($$v) {
        _vm.tooltipVisible = $$v
      },
      expression: "tooltipVisible"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tishi1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTooltip($event)
      }
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f046f23c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f046f23c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonTooltip.vue
// module id = 1606
// module chunks = 7